/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Link} from 'react-router-dom'
import {TopSellingDeal} from '../interface/IDashboardModel'
import {KTSVG} from '../../../../_metronic/helpers'
import NoData from '../../../components/common/NoData'

type Props = {
  className: string
  deals: TopSellingDeal[]
}

const TopDeals: React.FC<Props> = ({className, deals}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title fw-bolder text-dark'>Top Deals</h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          {/* <Dropdown1 /> */}
          {/* end::Menu */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-2'>
        {/* begin::Item */}
        {deals && deals.length > 0 ? (
          deals.splice(0, 5).map((e, idx) => (
            <div key={idx} className='d-flex align-items-center mb-7'>
              {/* begin::Avatar */}
              <div className='symbol symbol-50px me-5'>
                <img src={e.image[0]} className='' alt='' />
              </div>
              {/* end::Avatar */}
              {/* begin::Text */}
              <div className='flex-grow-1'>
                <Link
                  to={`/deal/view/${e._id}`}
                  className='text-dark fw-bolder text-hover-primary fs-6'
                >
                  {e.title}
                </Link>
                <span className='text-muted d-block fw-bold'>Rs. {e.deals.display_price}</span>
              </div>
              {/* end::Text */}
            </div>
          ))
        ) : (
          <NoData />
        )}
        {/* end::Item */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {TopDeals}
